var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80078 14.0954C5.07692 14.0954 5.30078 14.3192 5.30078 14.5954V20.2169C5.30078 20.493 5.07692 20.7169 4.80078 20.7169C4.52464 20.7169 4.30078 20.493 4.30078 20.2169V14.5954C4.30078 14.3192 4.52464 14.0954 4.80078 14.0954Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0338 11.8081C11.2973 11.8907 11.444 12.1712 11.3614 12.4347L9.6344 17.9446H4.87776C4.60162 17.9446 4.37776 17.7208 4.37776 17.4446C4.37776 17.1685 4.60162 16.9446 4.87776 16.9446H8.89986L10.4071 12.1357C10.4897 11.8721 10.7703 11.7255 11.0338 11.8081Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28322 5.41325L5.28862 9.23861C5.19384 9.7457 5.49744 10.2585 6.0148 10.4178L15.5299 12.9064L16.9762 7.25267L7.43786 4.75803L7.42932 4.75547C6.95152 4.61213 6.44541 4.88687 6.28322 5.41325ZM7.70752 3.79492C6.65085 3.48339 5.62462 4.12837 5.32294 5.13396L5.32027 5.14285L4.31327 9.01593L4.31048 9.0299C4.10519 10.0563 4.72142 11.0739 5.73518 11.378L5.74372 11.3806L16.2495 14.1282L18.1915 6.53688L7.70752 3.79492Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8317 7.52456L19.2453 8.10381C19.4931 8.16578 19.7314 8.30415 19.8827 8.54186C20.0366 8.78361 20.0596 9.06422 19.9941 9.32622L19.224 12.4065C19.162 12.6544 19.0237 12.8927 18.786 13.0439C18.545 13.1973 18.2655 13.2207 18.0042 13.156L15.5924 12.5771L16.8317 7.52456ZM17.5659 8.72916L16.803 11.8393L18.2442 12.1851C18.2453 12.1854 18.2463 12.1857 18.2474 12.186C18.2495 12.1799 18.2517 12.1726 18.2539 12.1639L19.0239 9.08368C19.0242 9.08258 19.0245 9.0815 19.0247 9.08046C19.0191 9.07849 19.0123 9.07643 19.0045 9.07441L17.5659 8.72916Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCamera);
export default __webpack_public_path__ + "static/media/security_camera.8a45d6a2a124f1e392f63d475b290b42.svg";
export { ForwardRef as ReactComponent };